import React from 'react';
import { Box } from '@mui/material';
import { MytaStreamsProvider } from './MytaStreamsProvider';
import { PixelStreamingWrapper } from './PixelStreamingWrapper';

const MytaStreams = () => {
  return (
    <Box>
      <MytaStreamsProvider>
        <PixelStreamingWrapper />
      </MytaStreamsProvider>
    </Box>
  );
};

export default MytaStreams;
